export default __webpack_public_path__ + "static/media/icons-system-information-line.c0de0375.svg";